var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code"},[_c('img',{attrs:{"src":_vm.wechatImg,"alt":""}}),_c('p',[_vm._v("微信扫码")])])
}
var staticRenderFns = []

export { render, staticRenderFns }